// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"16df6955","299":"9a580603"}[chunkId] + ".chunk.css";
};